import {useRef} from "react";

/**
 * @param {T & {[string]: any}} data
 * @returns {{current: T & {[string]: any}}}
 */
const useRefData = (data) => {
  const refData = useRef(data);
  for (const key in data) {
    refData.current[key] = data[key];
  }
  return refData;
};

export default useRefData;
